import MenuCArd1 from "../Assets/cold_cut_ham.png";
import MenuCArd2 from "../Assets/shredded_chicken.png";
import MenuCArd3 from "../Assets/pate_pork_meatloaf.png";
import MenuCArd4 from "../Assets/grilled_pork.png";
import MenuCArd5 from "./../Assets/grilled_chicken_banh_mi.png";
import MenuCArd6 from "./../Assets/special_combination.png";
import MenuCArd8 from "./../Assets/fried_egg.png";
import MenuCArd9 from "../Assets/grilled_beef.png";
import MenuCArd10 from "../Assets/ham_cheese_croissant_sandwich_1200x900.png";

import productImg1 from "../Assets/img/1.jpg";
import productImg2 from "../Assets/img/2.png";
import productImg3 from "../Assets/img/3.jpeg";
import productImg4 from "../Assets/img/4.jpg";
import productImg5 from "../Assets/img/5.jpeg";

export const products = [
  {
    id: 1,
    description: 'Sweet preserved lotus seeds',
    name: 'CANDIED LOTUS SEEDS',
    image: productImg1,
    BagPrice: '$12',
    BoxPrice: '$25',
    varityPrice: '',
    rating: 4.5,
  },
  {
    id: 2,
    description:
      'CANDIED COCONUT STRINGS (Flavors include: original, pandan, durian, strawberry)',
    name: 'CANDIED COCONUT STRINGS',
    image: productImg2,
    BagPrice: '$12',
    BoxPrice: '$24',
    varityPrice: '',
    rating: 4.8,
  },
  {
    id: 3,
    description: 'Hard candy bars made with peanuts',
    name: 'VIETNAMESE PEANUT CANDY',
    image: productImg4,
    BagPrice: '$10',
    BoxPrice: '$20',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 4,
    description: 'Thin, crispy peanut brittle',
    name: 'VIETNAMESE PEANUT BRITTLE',
    image: productImg5,
    BagPrice: '',
    BoxPrice: '$20',
    varityPrice: '',
    rating: 4.8,
  },
  {
    id: 5,
    description: 'Sweet & savory dried beef',
    name: 'VIETNAMESE BEEF JERKY',
    image: productImg1,
    BagPrice: '',
    BoxPrice: '$20',
    varityPrice: '',
    rating: 4.5,
  },
  {
    id: 6,
    description: 'Vegan sweet & savory beef jerky',
    name: 'VEGAN VIETNAMESE BEEF JERKY',
    image: productImg2,
    BagPrice: '',
    BoxPrice: '$40',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 7,
    description: 'Sweet-tart candied soursop',
    name: 'CANDIED SOURSOP',
    image: productImg3,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 8,
    description: 'Mix of candied soursop & tamarind',
    name: 'CANDIED SOURSOP & CANDIED TAMARIND',
    image: productImg4,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 9,
    description: 'Spicy candied tamarind',
    name: 'SPICY DRIED TAMARIND',
    image: productImg5,
    BagPrice: '$12',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 10,
    description: 'Crystallized winter melon strips',
    name: 'CANDIED WINTER MELON',
    image: productImg2,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 11,
    description: 'Sweet-spicy lemon & ginger candy',
    name: 'LEMON GINGER CANDY',
    image: productImg1,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 12,
    description: 'Mix of lemon ginger & kumquat-ginger candies',
    name: 'LEMON GINGER CANDY & KUMQUAT GINGER CANDY',
    image: productImg3,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 13,
    description: 'Sweet-spicy citrus candy with ginger',
    name: 'KUMQUAT GINGER CANDY',
    image: productImg4,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 14,
    description: 'Preserved water chestnuts with crunchy texture',
    name: 'CANDIED WATER CHESTNUT',
    image: productImg5,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 15,
    description: 'Chewy fruit candy with sweet-sour taste',
    name: 'CANDIED TAMARIND',
    image: productImg1,
    BagPrice: '$12',
    BoxPrice: '$24',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 16,
    description: 'Vietnamese fruit jelly candies',
    name: 'VIETNAMESE JELLY CANDY',
    image: productImg2,
    BagPrice: '$10',
    BoxPrice: '',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 17,
    description: 'Sweet-savory dried fruit with ginger kick',
    name: 'SALTED DRIED APRICOT',
    image: productImg3,
    BagPrice: '$11',
    BoxPrice: '$22',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 18,
    description: 'Sugar-free sweet & savory dried fruit with ginger kick',
    name: 'SALTED DRIED APRICOT (NO SUGAR)',
    image: productImg4,
    BagPrice: '$13',
    BoxPrice: '$26',
    varityPrice: '',
    rating: 5,
  },
  {
    id: 19,
    description: 'Assorted soft mini cakes without eggs',
    name: '9-PIECE VARIETY SOFT MINI CAKE BOX (NO EGGS)',
    image: productImg5,
    BagPrice: '',
    BoxPrice: '',
    varityPrice: '$45',
    rating: 5,
  },
  {
    id: 20,
    description: 'Assorted soft mini cakes with eggs',
    name: '9-PIECE VARIETY SOFT MINI CAKE BOX (WITH EGGS)',
    image: productImg1,
    BagPrice: '',
    BoxPrice: '',
    varityPrice: '$50',
    rating: 5,
  },
  {
    id: 21,
    description: 'Variety box of assorted candied fruits',
    name: 'ASSORTED CANDIED FRUIT BOX',
    image: productImg2,
    BagPrice: '',
    BoxPrice: '',
    varityPrice: '$45-$60',
    rating: 5,
  },
  {
    id: 22,
    description: 'Crunchy brittle with peanuts & sesame',
    name: 'VIETNAMESE PEANUT & SESAME BRITTLE',
    image: productImg3,
    BagPrice: '$10',
    BoxPrice: '',
    varityPrice: '',
    rating: 5,
  },
];

export const menuItems = [
  { 
    img: MenuCArd1, 
    title: 'Cold Cut Ham', 
    subTitle: 'Thịt Nguội', 
    link: "/cold-cut-ham" 
  },
  { 
    img: MenuCArd2, 
    title: 'Shredded Chicken', 
    subTitle: 'Gà Xé', 
    link: "/shredded-chicken" 
  },
  { 
    img: MenuCArd3, 
    title: 'Pate Pork Meat Loaf', 
    subTitle: 'Pâté Chả Luạ', 
    link: "/pate-pork-meatloaf" 
  },
  { 
    img: MenuCArd4, 
    title: 'Grilled Pork', 
    subTitle: 'Thịt Nướng', 
    link: "/grilled-pork" 
  },
  { 
    img: MenuCArd5, 
    title: 'Grilled Chicken', 
    subTitle: 'Gà Nướng', 
    link: "/grilled-chicken" 
  },
  { 
    img: MenuCArd6, 
    title: 'Special Combination', 
    subTitle: 'Đặc Biệt', 
    link: "/special-combination" 
  },
  { 
    img: MenuCArd8, 
    title: 'Fried Egg', 
    subTitle: 'Trứng Ốp La', 
    link: "/fried-egg" 
  },
  { 
    img: MenuCArd9, 
    title: 'Grilled Beef', 
    subTitle: 'Bò Nướng', 
    link: "/grilled-beef" 
  },
  { 
    img: MenuCArd10, 
    title: 'Ham & Cheese Croissant Sandwich', 
    subTitle: 'Jambon & Phô Mai', 
    link: "/ham-and-cheese-croissant-sandwich" 
  },
];

export const BanhMiItems = [
  { 
    img: MenuCArd1, 
    title: 'Cold Cut Ham - $7.50', 
    subTitle: 'Thịt Nguội', 
    link: "/cold-cut-ham"  
  },
  { 
    img: MenuCArd2, 
    title: 'Shredded Chicken - $8.00', 
    subTitle: 'Gà Xé', 
    link: "/shredded-chicken"  
  },
  { 
    img: MenuCArd3, 
    title: 'Pate Pork Meat Loaf - $7.50', 
    subTitle: 'Pâté Chả Luạ', 
    link: "/pate-pork-meatloaf"  
  },
  { 
    img: MenuCArd4, 
    title: 'Grilled Pork - $8.00', 
    subTitle: 'Thịt Nướng', 
    link: "/grilled-pork"  
  },
  { 
    img: MenuCArd5, 
    title: 'Grilled Chicken - $8.00', 
    subTitle: 'Gà Nướng', 
    link: "/grilled-chicken"  
  },
  { 
    img: MenuCArd6, 
    title: 'Special Combination - $8.50', 
    subTitle: 'Đặc Biệt', 
    link: "/special-combination" 
  },
  { 
    img: MenuCArd8, 
    title: 'Fried Egg - $7.50', 
    subTitle: 'Trứng Ốp La', 
    link: "/fried-egg"  
  },
  { 
    img: MenuCArd9, 
    title: 'Grilled Beef - $8.00', 
    subTitle: 'Bò Nướng', 
    link: "/grilled-beef"  
  },
];
